import { AnalyticsEvent } from './events';
import { CommonPayload } from './types';

const toSnakeCase = (str: string): string => {
  return str
    .replace(/\s+/g, '_')
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .toLowerCase();
};

export const RUDDERSTACK_EVENTS = [
  AnalyticsEvent.SELECT_LOCATION,
  AnalyticsEvent.EMAIL_SIGNIN_SUCCESS,
  AnalyticsEvent.APPLE_SIGNIN_SUCCESS,
  AnalyticsEvent.GOOGLE_SIGNIN_SUCCESS,
  AnalyticsEvent.SIGNUP_SUCCESS,
  AnalyticsEvent.SELECT_PROFESSIONAL,
  AnalyticsEvent.SELECT_ANY_PROFESSIONAL,
  AnalyticsEvent.SELECT_SERVICES,
  AnalyticsEvent.SELECT_DATE_AND_TIME,
  AnalyticsEvent.CONFIRM_PAYMENT,
  AnalyticsEvent.CONFIRM_RESERVATION,
  AnalyticsEvent.PAYMENT_SUCCESS,
  AnalyticsEvent.PAYMENT_FAILURE,
];

export const convertForRudderstack = (
  event: AnalyticsEvent,
  payload: CommonPayload,
): { event: string; payload: Record<string, unknown> } | null => {
  if (!RUDDERSTACK_EVENTS.includes(event)) {
    return null;
  }

  if (event === AnalyticsEvent.SELECT_LOCATION) {
    return {
      event: 'location_selected',
      payload: {
        ...payload,
      },
    };
  }

  if (
    [
      AnalyticsEvent.EMAIL_SIGNIN_SUCCESS,
      AnalyticsEvent.APPLE_SIGNIN_SUCCESS,
      AnalyticsEvent.GOOGLE_SIGNIN_SUCCESS,
      AnalyticsEvent.SIGNUP_SUCCESS,
    ].includes(event)
  ) {
    const methods = {
      [AnalyticsEvent.EMAIL_SIGNIN_SUCCESS]: 'email_login',
      [AnalyticsEvent.APPLE_SIGNIN_SUCCESS]: 'apple',
      [AnalyticsEvent.GOOGLE_SIGNIN_SUCCESS]: 'google',
      [AnalyticsEvent.SIGNUP_SUCCESS]: 'email_signup',
    };

    const loginMethod = methods[event];

    return {
      event: 'user_signed_in',
      payload: {
        ...payload,
        login_method: loginMethod,
      },
    };
  }

  return {
    event: toSnakeCase(event),
    payload: {
      ...payload,
    },
  };
};
